import axios from '@/jslib/axios'

export const getPartnershipList = params => {
  return axios({
    method: 'get',
    url: '/admin/partnership/inquiries/list',
    params
  })
}

export const getPartnershipDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/partnership/inquiries/detail',
    params
  })
}

export const deletePartnership = data => {
  return axios({
    method: 'delete',
    url: '/admin/partnership/inquiries/delete',
    data
  })
}